import { Radar } from "lucide-react";

export function ScannerBoard({ rows = [] }) {
  return (
    <div data-testid="scanner-board">
      <div className="flex items-center gap-2 px-4 mb-2">
        <Radar size={14} className="text-brand" />
        <h2 className="text-xs font-bold uppercase tracking-[0.15em] text-muted2">Momentum Scanner</h2>
      </div>
      <div className="mx-4 border border-edge rounded-sm overflow-hidden bg-surface">
        <div className="grid grid-cols-12 px-3 py-2 text-[10px] uppercase tracking-wider text-muted2 border-b border-edge">
          <span className="col-span-4">Symbol</span>
          <span className="col-span-3 text-right">LTP</span>
          <span className="col-span-3 text-right">Mom%</span>
          <span className="col-span-2 text-right">RVol</span>
        </div>
        <div className="max-h-[280px] overflow-y-auto no-scrollbar">
          {rows.map((r) => {
            const up = r.momentum_pct >= 0;
            return (
              <div
                key={r.symbol}
                className={`grid grid-cols-12 px-3 py-2 items-center border-b border-edge/50 ${r.eligible ? "bg-pos/[0.04]" : ""}`}
                data-testid={`scanner-row-${r.symbol}`}
              >
                <span className="col-span-4 flex items-center gap-1.5">
                  {r.eligible && <span className="h-1.5 w-1.5 rounded-full bg-pos" />}
                  {r.in_position && <span className="text-[9px] px-1 rounded-sm bg-brand/20 text-brand font-bold">IN</span>}
                  <span className="font-semibold text-xs truncate">{r.symbol}</span>
                </span>
                <span className="col-span-3 text-right mono text-xs text-white">
                  {r.ltp.toLocaleString("en-IN", { maximumFractionDigits: 1 })}
                </span>
                <span className="col-span-3 text-right mono text-xs font-bold" style={{ color: up ? "#00E676" : "#FF3B30" }}>
                  {up ? "+" : ""}{r.momentum_pct.toFixed(2)}
                </span>
                <span className="col-span-2 text-right mono text-xs text-muted2">{r.rel_volume.toFixed(1)}</span>
              </div>
            );
          })}
          {rows.length === 0 && (
            <div className="px-3 py-6 text-center text-xs text-muted2">Warming up scanner…</div>
          )}
        </div>
      </div>
    </div>
  );
}
